export const createResponseObject = (context) => {
  const response = {  
    code: context.response?.status || 200,
    status: context.response?.statusText || 'OK',
    responseTime: context.response?.responseTime || 0,
    responseSize: context.response?.responseSize || 0,
    body: context.response?.body || context.response?.originalResponse || '',

    // Distinct name so the helper object below does not shadow it.
    rawHeaders: context.response?.headers || {},

    headers: {
      all: () => context.response?.headers || {},
      get: (headerName) => {
        const headers = context.response?.headers || {};
        return headers[headerName.toLowerCase()] || headers[headerName];
      },
      has: (headerName) => {
        const headers = context.response?.headers || {};
        return headerName.toLowerCase() in headers || headerName in headers;
      }
    },
    
    text: () => {
      if (typeof context.response?.body === 'string') return context.response.body;
      if (typeof context.response?.originalResponse === 'string') return context.response.originalResponse;
      return JSON.stringify(context.response?.body || context.response?.originalResponse || {});
    },
    
    json: () => {
      try {
        if (context.response?.originalResponse) {
          if (typeof context.response.originalResponse === 'string') {
            return JSON.parse(context.response.originalResponse);
          } else if (typeof context.response.originalResponse === 'object') {
            return context.response.originalResponse;
          }
        }
        if (typeof context.response?.body === 'object') return context.response.body;
        if (typeof context.response?.body === 'string') return JSON.parse(context.response.body);
        return context.response?.body || context.response?.originalResponse || {};
      } catch (error) {
        console.warn('[SCRIPT-EXECUTOR] Failed to parse response JSON:', error);
        return context.response?.body || context.response?.originalResponse || {};
      }
    },
    
    xml: () => {
      console.warn('XML parsing not fully implemented');
      return context.response?.body || context.response?.originalResponse || '';
    },
    
    html: () => {
      return context.response?.body || context.response?.originalResponse || '';
    },
    
    cookies: {
      all: () => context.response?.cookies || [],
      get: (cookieName) => {
        const cookie = (context.response?.cookies || []).find(c => c.name === cookieName);
        return cookie ? cookie.value : null;
      },
      has: (cookieName) => {
        return (context.response?.cookies || []).some(c => c.name === cookieName);
      },
      jar: () => {
        return {
          get: (domain, path, name) => response.cookies.get(name),
          set: (domain, path, name, value) => console.log(`Setting cookie: ${name}=${value}`),
          unset: (domain, path, name) => console.log(`Unsetting cookie: ${name}`),
          clear: () => console.log('Clearing all cookies')
        };
      }
    },
    
    to: {
      have: {
        status: (expectedStatus) => {
          if (response.code !== expectedStatus) {
            throw new Error(`Expected status ${expectedStatus}, but got ${response.code}`);
          }
        },
        header: (headerName, expectedValue) => {
          const actualValue = response.headers.get(headerName);
          if (expectedValue instanceof RegExp) {
            if (!expectedValue.test(actualValue)) {
              throw new Error(`Expected header '${headerName}' to match ${expectedValue}, but got '${actualValue}'`);
            }
          } else {
            if (actualValue !== expectedValue) {
              throw new Error(`Expected header '${headerName}' to be '${expectedValue}', but got '${actualValue}'`);
            }
          }
        }
      }
    }
  };
  
  return response;
};
